import React, { useEffect, useState } from 'react'
import {
  Modal, Form, Input, Switch, message, Select,
} from 'antd'

import { fetch } from '../../utils/fetch'

const { Option } = Select
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
}

const EmailModal = ({
  visible, onSuccess, onCancel, editItem,
}) => {
  const [siteList, setSiteList] = useState([])
  const [subjectList, setSubjectList] = useState([])
  const [action, setAction] = useState('')
  const [form] = Form.useForm()

  const fetchSubjectEmail = () => {
    fetch({
      url: '/master/subject-email',
    }).then((res) => {
      if (res.data?.success) {
        setSubjectList(res.data?.data)
      }
    })
  }
  const fetchSite = () => {
    fetch({
      url: '/master/site',
    }).then((res) => {
      if (res.data?.success) {
        setSiteList(res.data?.data)
      }
    })
  }

  useEffect(() => {
    fetchSubjectEmail()
    fetchSite()
  }, [])

  const postManagementEmail = (values) => {
    fetch({
      method: 'POST',
      url: '/management/email',
      data: values,
    }).then((res) => {
      if (res?.data?.success) {
        form.resetFields()
        message.success('Email created.')
        onSuccess(values)
      } else {
        message.error(res?.data?.message)
      }
    })
  }

  const putManagementEmail = (values) => {
    fetch({
      method: 'PUT',
      url: '/management/email',
      data: values,
    }).then((res) => {
      if (res?.data?.success) {
        form.resetFields()
        message.success('Email updated.')
        onSuccess(values)
      } else {
        message.error(res?.data?.message)
      }
    })
  }

  useEffect(() => {
    if (!editItem) {
      form.resetFields()
      setAction('Create New')
    } else {
      setAction('Edit')
    }
    form.setFieldsValue(editItem)
  }, [editItem, form])

  useEffect(() => {
    if (!editItem) {
      form.setFieldsValue({
        email: '',
        username: '',
        isActive: true,
      })
    }
  }, [visible])

  return (
    <Modal
      title={`${action} Email`}
      visible={visible}
      maskClosable={false}
      okText="Submit"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            if (action === 'Create New') postManagementEmail(values)
            if (action === 'Edit') putManagementEmail(values)
          })
          .catch((info) => {
            console.log('Validate Failed:', info)
          })
      }}
    >
      <Form
        {...layout}
        form={form}
        name="email_form"
        layout="horizontal"
        initialValues={editItem}
        preserve={false}
      >
        <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
          <Input disabled={editItem} />
        </Form.Item>
        <Form.Item name="siteCode" label="Site" rules={[{ required: true }]}>
          <Select
            placeholder="Select a site"
            allowClear
          >
            {
              siteList.length > 0
                ? siteList.map((site) => <Option key={`select-site-${site.siteCode}`} value={site.siteCode}>{site.siteCode} - {site.siteDescr}</Option>)
                : <Option value="" />
            }
          </Select>
        </Form.Item>
        <Form.Item name="subjectCode" label="Subject" rules={[{ required: true }]}>
          <Select
            placeholder="Select a subject email"
            mode="multiple"
          >
            {
              subjectList.length > 0
                ? subjectList.map((site) => <Option key={`select-subject-${site.subjectCode}`} value={site.subjectCode}>{site.subjectDescr}</Option>)
                : <Option value="" />
            }
          </Select>
        </Form.Item>
        <Form.Item name="isActive" label="Status" valuePropName="checked">
          <Switch defaultChecked />
        </Form.Item>
      </Form>
    </Modal>

  )
}

export default EmailModal
